export default __webpack_public_path__ + "static/media/03.fd356ce4.jpg";